export default "__VITE_ASSET__BsapwsZS__"